module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resetNickname"
  }, [_c('mt-header', {
    staticStyle: {
      "height": "8vh",
      "font-size": "18px"
    },
    attrs: {
      "title": "修改昵称"
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/me"
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "nicknameFrom"
  }, [_c('div', {
    staticClass: "nicknameInput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNickname),
      expression: "newNickname"
    }],
    attrs: {
      "placeholder": "请输入昵称"
    },
    domProps: {
      "value": (_vm.newNickname)
    },
    on: {
      "blur": _vm.NicknameBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newNickname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("2-20个字符，可由中英文、数字、“_”、“-”组成")])]), _vm._v(" "), _c('mt-button', {
    staticStyle: {
      "width": "90vw",
      "margin": "8vh 0 0 5vw"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.commitNickname()
      }
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f951f036","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/resetNickname.vue
// module id = 1302
// module chunks = 1